var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultistar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-188wmy4",
    "aria-label": "stars",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M3.49609 16.7941C5.70615 16.7941 7.49776 18.5858 7.49776 20.7958C7.49776 18.5858 9.28937 16.7941 11.4994 16.7941C9.28937 16.7941 7.49776 15.0025 7.49776 12.7925C7.49776 15.0025 5.70615 16.7941 3.49609 16.7941Z M13.5 13.7927C15.7101 13.7927 17.5017 15.5843 17.5017 17.7943C17.5017 15.5843 19.2933 13.7927 21.5033 13.7927C19.2933 13.7927 17.5017 12.0011 17.5017 9.79102C17.5017 12.0011 15.7101 13.7927 13.5 13.7927V13.7927Z M7.49609 6.78975C9.70615 6.78975 11.4978 8.58136 11.4978 10.7914C11.4978 8.58136 13.2894 6.78975 15.4994 6.78975C13.2894 6.78975 11.4978 4.99815 11.4978 2.78809C11.4978 4.99815 9.70615 6.78975 7.49609 6.78975Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultistar);
export default __webpack_public_path__ + "static/media/multistar.2d1bc25570a4ace78074ed8e60f7b3c4.svg";
export { ForwardRef as ReactComponent };